import { render, staticRenderFns } from "./ValueAdjustmentList.vue?vue&type=template&id=253c0b1d&scoped=true&"
import script from "./ValueAdjustmentList.vue?vue&type=script&lang=js&"
export * from "./ValueAdjustmentList.vue?vue&type=script&lang=js&"
import style0 from "./ValueAdjustmentList.vue?vue&type=style&index=0&id=253c0b1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253c0b1d",
  null
  
)

export default component.exports